import { Plus, RotateCcw } from 'lucide-react'
import { formatStylizedDate } from '../format'
import { Button } from '../shadcn/button'
import { Tabs, TabsList, TabsTrigger } from '../shadcn/tabs'

export type ViewMode = 'split' | 'chronological' | 'monthly'

export interface YearBarProps {
  years: number[]
  selectedYear: number
  onSelectYear: (year: number) => void
  totalEntries: number
  rendimentosCount: number
  impostosCount: number
  lastUpdatedAt?: string
  viewMode: ViewMode
  onViewModeChange: (mode: ViewMode) => void
  onNew?: () => void
  onRecalcAll?: () => void
}

export function YearBar({
  years,
  selectedYear,
  onSelectYear,
  totalEntries,
  rendimentosCount,
  impostosCount,
  lastUpdatedAt,
  viewMode,
  onViewModeChange,
  onNew,
  onRecalcAll,
}: YearBarProps) {
  return (
    <div className="border-b border-border bg-muted/30">
      <div className="container flex items-center justify-between py-5">
        <div className="flex items-center gap-6">
          <div>
            <label
              htmlFor="year-select"
              className="text-muted-foreground text-[10px] font-medium tracking-widest2 uppercase"
            >
              Ano-base
            </label>
            <select
              id="year-select"
              value={selectedYear}
              onChange={(e) => onSelectYear(Number(e.target.value))}
              className="font-display block bg-transparent text-3xl leading-none focus:outline-none cursor-pointer"
            >
              {years.map((y) => (
                <option key={y} value={y} className="font-sans text-base">
                  {y}
                </option>
              ))}
            </select>
          </div>
          <div className="text-muted-foreground hidden text-[12px] leading-tight sm:block">
            <div>
              <span className="text-foreground font-medium">{totalEntries}</span> lançamentos ·{' '}
              <span className="text-success font-medium">{rendimentosCount}</span> rendimentos ·{' '}
              <span className="text-destructive font-medium">{impostosCount}</span> impostos
            </div>
            {lastUpdatedAt ? (
              <div className="mt-0.5">
                última atualização{' '}
                <span className="font-mono">
                  {formatStylizedDate(lastUpdatedAt.slice(0, 10))}
                </span>
              </div>
            ) : null}
          </div>
        </div>
        <div className="flex items-center gap-3">
          <Tabs
            value={viewMode}
            onValueChange={(v) => onViewModeChange(v as ViewMode)}
          >
            <TabsList>
              <TabsTrigger value="split">Por tipo</TabsTrigger>
              <TabsTrigger value="chronological">Cronológico</TabsTrigger>
              <TabsTrigger value="monthly">Mensal</TabsTrigger>
            </TabsList>
          </Tabs>
          <Button
            variant="outline"
            size="sm"
            onClick={onRecalcAll}
            disabled={totalEntries === 0}
          >
            <RotateCcw />
            Recalcular
          </Button>
          <Button size="sm" onClick={onNew}>
            <Plus />
            Novo lançamento
          </Button>
        </div>
      </div>
    </div>
  )
}
